import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import entries from "lodash/entries";

export function RadioSelect<T extends string>(props: {
  value: T;
  options: Record<T, string>;
  onChange(v: T): void;
  disabled?: boolean;
}) {
  return (
    <RadioGroup row value={props.value} onChange={(e) => props.onChange(e.target.value as T)} sx={{ mb: 3 }}>
      {entries<string>(props.options).map(([value, label], index) => (
        <FormControlLabel
          key={value}
          value={value}
          label={label}
          control={<Radio color="primary" />}
          sx={index > 0 ? { ml: { xs: 0, sm: 4 } } : undefined}
          disabled={props.disabled ?? false}
        />
      ))}
    </RadioGroup>
  );
}
